import Vue from 'vue'
import Vuex from 'vuex'
import demo from './modules/demo'
import common from './modules/common'
import shangtang from './modules/shangtang'
import xingshan from './modules/xingshan'
import transition from './modules/transition'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    common,
    demo,
    transition,
    shangtang,
    xingshan
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js